import immutableStore from 'utils/immutableStore';
import alt from 'components/Dispatcher';
import {Record, Map} from 'immutable';
import CrmAccountActions from 'actions/crm-opp-ui/CrmAccountActions';

@immutableStore
class CrmAccountStore {
  constructor() {
    this.state = new Record({
      scorecards: undefined,

      // most recent fetched account
      account: null,

      // all fetched accounts.  Triggers uses this
      accounts: Map(),

      searchTerm: null,
      searchResults: null,
      isSearching: false,
    })();

    this.bindActions(CrmAccountActions);
  }

  onSearchAccounts(term) {
    this.setState({
      isSearching: true,
      searchTerm: term,
    });
  }

  searchAccountsSuccess(accounts) {
    this.setState({
      isSearching: false,
      searchResults: accounts,
    });
  }

  searchAccountsError(response) {
    console.warn(response);
    this.setState({
      isSearching: false,
      searchResults: null,
    });
  }

  fetchAccountSuccess(account) {
    this.setState({
      account,
      accounts: this.state.accounts.set(account.id, account),
    });
  }

  fetchAccountError(response) {
    console.warn(response);
    this.setState({
      account: null,
    });
  }

  onClearSearch() {
    this.setState({
      searchResults: null,
      searchTerm: null,
      isSearching: false,
    });
  }

  onSetSearchTerm(term) {
    this.setState({
      searchTerm: term,
    });
  }
}

export default alt.createStore(CrmAccountStore, 'CrmAccountStore');
